import * as React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Style } from '../styles'
import BizzeyLogo from '../components/BizzeyLogo'

const Container = styled.a`
	display: flex;
	flex-direction: row;
	align-items: center;
`

const Description = styled.div`
	color: #666260;
	margin-right: ${Style.spacing.x1_5};
`

const PoweredBy = () => {
	const { t } = useTranslation()
	return (
		<Container href='https://www.bizzey.com'>
			<Description>{t('PoweredBy::Powered by')}</Description>
			<BizzeyLogo wordmarkColor='#000000' />
		</Container>
	)
}

export default PoweredBy